const navBtn = $("#js_navButton");
const nav = $("#js_nav");
navBtn.on("click", function () {
  navBtn.toggleClass("active");
  nav.toggleClass("active");
});
